export class ScorecardAvailableRoundsQuerySource {
    constructor(scoreCards) {
        this.scoreCards = scoreCards;
    }
    queryScorecards(conditions) {
        const mutableConditions = conditions.map(condition => [
            condition[0],
            condition[1],
            condition[2],
        ]);
        return this.scoreCards.queryScorecards(mutableConditions);
    }
}
//# sourceMappingURL=ScorecardAvailableRoundsQuerySource.js.map